import { ApolloProvider } from "@apollo/client";
import client from "./apollo-client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import FundDetails from "./pages/FundDetails";
import Insights from "./pages/Insights";
import Sectors from "./pages/Sectors";
import Stocks from "./pages/Stocks";
import PortfolioOverlap from "./pages/PortfolioOverlap";
// const GET_HOLDINGS = gql`
//   query GetAllHoldings {
//     getAllHoldings {
//       id
//       stockName
//       stockSector
//       quantity
//       valueInMn
//       percentageOfTotalHoldings
//       oneMonthChange
//       oneMonthQtyChange
//       oneYearHighestPt
//       oneYearLowestPt
//     }
//   }
// `;

// function FundList() {
//   const { loading, error, data } = useQuery(GET_HOLDINGS);

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error.message}</p>;

//   return (
//     <div>
//       <h1>Mutual Fund Holdings</h1>
//       <table border="1" style={{ borderCollapse: "collapse", width: "100%" }}>
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Stock Name</th>
//             <th>Stock Sector</th>
//             <th>Value in Mn</th>
//             <th>One Month Change (%)</th>
//             <th>One Month Quantity Change</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.getAllHoldings.map((holding) => (
//             <tr key={holding.id}>
//               <td>{holding.id}</td>
//               <td>{holding.stockName}</td>
//               <td>{holding.stockSector}</td>
//               <td>{holding.valueInMn.toFixed(2)}</td>
//               <td>
//                 {holding.oneMonthChange
//                   ? holding.oneMonthChange.toFixed(2)
//                   : "N/A"}
//               </td>
//               <td>
//                 {holding.oneMonthQtyChange
//                   ? holding.oneMonthQtyChange.toFixed(2)
//                   : "N/A"}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }

function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/fund-details/:id"
            element={<FundDetails key={window.location.pathname} />}
          />
          <Route path="/insights" element={<Insights />} />
          <Route path="/sectors" element={<Sectors />} />
          <Route path="/stocks" element={<Stocks />} />
          <Route path="/portfolio-overlap" element={<PortfolioOverlap />} />
        </Routes>
      </Router>
    </ApolloProvider>
  );
}

export default App;
